"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Builder = _interopRequireDefault(require("./Builder"));
var _settings = require("./Builder/settings.js");
var _Player = _interopRequireDefault(require("./Player"));
var _settings2 = require("./Player/settings.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = {
  code: 'matrix',
  name: 'Matrix',
  labelField: 'question',
  icon: _settings.icon,
  builder: _Builder["default"],
  builderInitialValues: _settings.initialValues,
  player: _Player["default"],
  getPlayerInitialValue: _settings2.getInitialValue,
  getMetricsPrefix: _settings.getMetricsPrefix,
  getDataDefinitions: _settings.getDataDefinitions,
  getMetrics: _settings.getMetrics,
  ttsFields: _settings.ttsFields,
  getTotalQuestionNumbers: function getTotalQuestionNumbers(settings) {
    var total = 0;
    if (!settings.questionNumbersHide) {
      if (settings.questionNumbersForMainQuestion) {
        total++;
      }
      if (settings.questionNumbersForRows) {
        total += settings.rows.length;
      }
    }
    return total;
  },
  hasPrintVersion: true
};